import { motion, useReducedMotion } from "framer-motion";
import { Star } from "lucide-react";

const TESTIMONIALS = [
  {
    quote:
      "Cracked lounge room window replaced within the week. Fair price, turned up on time, and no mess left behind. Can't fault it.",
    name: "Karen T.",
    suburb: "Morphett Vale",
    testid: "testimonial-card-1",
  },
  {
    quote:
      "Fixed two sticking doors, patched the wall and mowed the jungle out back in a single visit. One call, all done.",
    name: "Dave & Sharon M.",
    suburb: "Hallett Cove",
    testid: "testimonial-card-2",
  },
  {
    quote:
      "Shower screen shattered on a Saturday morning. Measured up and sorted without the usual runaround. Legends.",
    name: "Mick R.",
    suburb: "Seaford",
    testid: "testimonial-card-3",
  },
];

const EASE = [0.16, 1, 0.3, 1];

const Stars = () => (
  <div className="flex gap-1" aria-label="5 out of 5 stars" role="img">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} className="h-4 w-4 fill-orange text-orange" aria-hidden="true" />
    ))}
  </div>
);

export const Testimonials = () => {
  const reduce = useReducedMotion();

  return (
    <section data-testid="testimonials-section" className="bg-sand pb-4 pt-20 md:pt-24">
      <div className="safe-x mx-auto max-w-7xl">
        <motion.div
          initial={reduce ? false : { opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: EASE }}
          className="flex flex-wrap items-end justify-between gap-6"
        >
          <div>
            <p className="eyebrow">Happy customers</p>
            <h2 className="mt-4 font-display text-4xl font-bold uppercase leading-[0.95] text-navy sm:text-5xl">
              Word from <span className="text-outline-orange">the south.</span>
            </h2>
          </div>
          <p className="flex items-center gap-3 font-display text-sm font-semibold uppercase tracking-[0.2em] text-navy/60">
            <Stars />
            5.0 from locals
          </p>
        </motion.div>

        <div className="mt-12 flex snap-x snap-mandatory gap-5 overflow-x-auto pb-4 lg:grid lg:grid-cols-3 lg:overflow-visible lg:pb-0">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.testid}
              data-testid={t.testid}
              initial={reduce ? false : { opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, ease: EASE, delay: i * 0.12 }}
              className="grain relative flex w-[85vw] shrink-0 snap-start flex-col justify-between border-l-8 border-orange bg-navy px-7 py-7 text-white sm:w-[380px] lg:w-auto"
            >
              <div>
                <Stars />
                <blockquote className="mt-5 text-sm leading-relaxed text-white/80 md:text-base">
                  &ldquo;{t.quote}&rdquo;
                </blockquote>
              </div>
              <figcaption className="mt-6 border-t border-white/10 pt-4">
                <p className="font-display text-base font-semibold uppercase tracking-wider text-orange">
                  {t.name}
                </p>
                <p className="text-xs uppercase tracking-wider text-white/50">{t.suburb}</p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
